export default __webpack_public_path__ + "static/immersive-audio-400-dc717191cf9eb42bb5a02ec131a230de.webp";